export const DOMAIN_ROUTES = {
  TEMPLATE_PREVIEW: 'template-preview',
  TEMPLATE_RENDER: 'template-render',
  UNDER_CONSTRUCTION: 'under-construction',
  NOT_FOUND: 'not-found',
};
